import classNames from 'classnames'
import { Badge } from 'maeng-daisyui'
import Message, { useTranslation } from 'maeng-utils/locale'
import React, { useMemo } from 'react'

type TimestampItem = {
  when: string
  title: string
  organizer: string
  tags: string[]
}

const Timestamp = () => {
  const { t } = useTranslation()

  const timestamps = useMemo<TimestampItem[]>(() => t('portfolio.timestamp.timestamps'), [t])

  return (
    <section className="mb-12">
      <Message
        i18nKey="portfolio.timestamp.title"
        className="text-3xl font-extrabold pt-5 pb-8"
        component="h2"
      />
      <div className="grid grid-cols-2 px-4 mb-20">
        {timestamps.map(({ when, title, organizer, tags }) => (
          <div
            className={classNames(
              'flex flex-col whitespace-pre-line',
              'odd:relative odd:pr-8 odd:border-r-2 odd:border-r-solid odd:border-r-[#ccd5dd] odd:text-right',
              'odd:before:top-[2rem] odd:before:right-[-0.05rem] odd:before:border odd:before:border-solid odd:before:border-[#8a8e94] odd:before:w-4',
              'odd:before:absolute odd:before:content-[""] odd:before:bg-white odd:before:self-center odd:first:before:animate-blink',
              'odd:after:absolute odd:after:content-[""] odd:after:bg-white odd:after:self-center odd:after:top-[1.58rem] odd:after:right-[-0.83rem] odd:after:rounded-lg odd:after:translate-x-[-50%] odd:after:border-2 odd:after:border-solid odd:after:border-[#8a8e94] odd:after:w-[12px] odd:after:h-[14px] odd:after:z-1 odd:first:after:animate-blink',
              'even:pt-[5.5rem] even:pl-8 even:relative even:items-start even:my-4',
              'even:before:top-[7.4rem] even:before:border even:before:border-solid even:before:border-[#8a8e94] even:before:w-4 even:before:absolute even:before:content-[""] even:before:left-[-0.05rem] even:before:bg-white even:before:self-center',
              'even:after:absolute even:after:content-[""] even:after:bg-white even:after:top-[7rem] even:after:left-[-0.05rem] even:after:rounded-lg even:after:translate-x-[-50%] even:after:border-2 even:after:border-solid even:after:border-[#8a8e94] even:after:w-[12px] even:after:h-[14px] even:after:z-1',
            )}
            key={when}
          >
            <div className="timestamp__main">
              <div className="text-sm text-[#3f4247]">{when}</div>
              <div className="text-base font-medium">{title}</div>
            </div>
            <div className="flex gap-1 text-[#8a8e94] leading-6 justify-end items-center">
              <div className="text-sm">{organizer}</div>
              {tags.map((tag) => (
                <Badge outlined color="ghost" size="sm" key={tag}>
                  {tag}
                </Badge>
              ))}
            </div>
            <div className="timestamp__description" />
          </div>
        ))}
      </div>
    </section>
  )
}

export default Timestamp
